import React from "react";
import "./Birthday.css";
import CakeIcon from "@material-ui/icons/Cake";

function Birthday({ name }) {
  return (
    <div className="birthday">
      <CakeIcon />
      <div>
        It's <span>{name}</span>s Birthday today.
      </div>
    </div>
  );
}

export default Birthday;
